import React, { useEffect, useState } from 'react'
import Switch from 'react-switch'
import { Col, FormGroup, Row, Alert, Input } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const TofuPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Calcium: item.Calcium,
    IsPlainRefrigerated: item.IsPlainRefrigerated,
  })
  const methods = useFormContext()
  const { onChangeReviewer, setSwitchReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item) {
      const { Calcium, IsPlainRefrigerated } = item
      setPackaging({
        Calcium,
        IsPlainRefrigerated,
      })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Calcium {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            placeholder={'Min 100mg calcium per 100g tofu'}
            defaultValue={packaging.Calcium}
            name="Calcium"
            control={methods.control}
            rules={{
              required: {
                value: true,
                message: '⚠ Calcium (mg) per 100g tofu is required.',
              },
              maxLength: {
                value: 6,
                message: '⚠ Calcium exceeds 6 characters.',
              },
              min: {
                value: 100,
                message:
                  '⚠ Calcium per 100g tofu is less than the 100mg minimum allowed.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Calcium"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
        <br />
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that this product is plain and refrigerated. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="IsPlainRefrigerated"
            id="IsPlainRefrigerated"
            defaultValue={packaging.IsPlainRefrigerated}
            onChange={([checked, event, id]) => {
              setSwitchReviewer(item, checked, event, id)
              return checked
            }}
            control={methods.control}
            checked={packaging.IsPlainRefrigerated}
            rules={{
              validate: IsPlainRefrigerated => IsPlainRefrigerated === true,
            }}
            disabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="IsPlainRefrigerated"
              message={
                '⚠ You must certify that this product is plain and refrigerated.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

TofuPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default TofuPackageReview
